<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content class="content-dialog">
  <div *ngIf="description" class="description" [innerHTML]="description"></div>
  <ng-container *ngIf="pricing$ | async as pricing; else displayStencil">
    <ng-container *ngIf="pricing.showContractPricing; else dontShowContractPricing">
      <ng-container *ngIf="pricing.showPricing">
        <p class="pricing-line">
          <span>{{ 'CHECKOUT.ESTIMATED_COST' | translate }}</span>
          <span class="cost">
            <div class="pricing-string">
              <span
                *ngIf="pricing.price?.discountAmount > 0"
                class="item-price-before-discount"
                matTooltipPosition="above"
                [matTooltip]="getDiscountDescription(pricing.price)"
              >
                {{ pricing.price?.subtotalCost | price : pricing.price?.currency }}
              </span>
              <span>{{ pricing.pricingString }}</span>
            </div>
            <div *ngIf="freeSnapshotsRemaining$ | async as ssr" class="free-snapshot-text">
              <span>
                {{
                  (ssr === 1 ? 'SUBSCRIPTIONS.FREE_REMAINING_CHECKOUT' : 'SUBSCRIPTIONS.FREE_REMAINING_CHECKOUT_MULTI')
                    | translate : { freeLeft: ssr }
                }}
              </span>
            </div>
          </span>
        </p>
      </ng-container>
    </ng-container>
    <app-instant-bill-payment-info
      [editable]="billingInfoEditable"
      [merchantId]="partnerId"
      [productSKU]="productSKU"
      [paymentRequired]="pricing.price?.totalCost > 0"
    ></app-instant-bill-payment-info>

    <ng-container *ngIf="shouldInferAccountData$ | async">
      <div class="missing-inference-info">
        <glxy-alert type="info">
          {{
            'SUBSCRIPTIONS.MISSING_ACCOUNT_FIELDS.DESCRIPTION'
              | translate
                : {
                    accountType:
                      ((accountType === 'company'
                        ? 'SUBSCRIPTIONS.MISSING_ACCOUNT_FIELDS.COMPANY'
                        : 'SUBSCRIPTIONS.MISSING_ACCOUNT_FIELDS.ACCOUNT'
                      ) | translate)
                  }
          }}
          <ul class="missing-inference-items">
            <li>{{ 'SUBSCRIPTIONS.MISSING_ACCOUNT_FIELDS.PHONE_NUMBER' | translate }}</li>
            <li>{{ 'SUBSCRIPTIONS.MISSING_ACCOUNT_FIELDS.ADDRESS' | translate }}</li>
            <li>{{ 'SUBSCRIPTIONS.MISSING_ACCOUNT_FIELDS.WEBSITE' | translate }}</li>
          </ul>
        </glxy-alert>
        <div class="consent-data-inference">
          <mat-checkbox [formControl]="isInferMissingData" color="primary">
            {{ 'SUBSCRIPTIONS.CONSENT_INFERENCE_CHECKBOX' | translate }}
          </mat-checkbox>
        </div>
      </div>
    </ng-container>

    <glxy-alert class="upgrade-alert" *ngIf="pricing.upgrade.show" type="success" icon="trending_up">
      <div
        class="upgrade-cta-text"
        [innerHtml]="
          pricing.upgrade.cta
            | translate
              : {
                  plan: 'SUBSCRIPTION_TIERS.' + pricing.upgrade.nextTierId + '.NAME' | translate,
                  limit: pricing.upgrade.nextTierLimit | translate
                }
        "
      ></div>
      <a class="upgrade-link-cta" [routerLink]="'/upgrade-subscription-tier'" target="_blank">
        {{ 'COMMON.ACTION_LABELS.UPGRADE' | translate }}
        <mat-icon class="open-cta-icon">open_in_new</mat-icon>
      </a>
    </glxy-alert>

    <ng-template #dontShowContractPricing>
      <p>*{{ 'CHECKOUT.STANDARD_FEES_APPLY' | translate }}</p>
    </ng-template>
  </ng-container>

  <ng-template #displayStencil>
    <div class="stencil-shimmer"></div>
  </ng-template>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button matDialogClose color="primary">
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    id="{{ createButtonId }}"
    [disabled]="(snapshotActionEnabled$ | async) === false"
    (click)="closeDialog()"
  >
    {{ successLabel }}
  </button>
</mat-dialog-actions>
